import { Avatar } from "@mui/material"
import type { FC } from "react"

import type { SalesRequester } from "../types"

export const isValidName = (value: string | null | undefined): value is string =>
  Boolean(value && value.trim() && value.trim() !== "null")

const getInitialsFromName = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0] ?? "")
    .join("")
    .toUpperCase()

interface SalespersonAvatarProps {
  salesPerson: Pick<SalesRequester, "name" | "initials">
}

export const SalespersonAvatar: FC<SalespersonAvatarProps> = ({ salesPerson }) => {
  const display = isValidName(salesPerson.initials) ? salesPerson.initials : getInitialsFromName(salesPerson.name)
  return <Avatar>{display}</Avatar>
}
